export default function roomTour(){
  // room tour
  const roomTourVideo = document.querySelectorAll('.room-tour__video');
  
  roomTourVideo.forEach(video => {
    video.addEventListener('click', () => {
      let dataIndex = video.dataset.modal;
      document.querySelector(`#${dataIndex}`).classList.add('active');
    })
  })

}